import { UseLoadingReturn } from "@/hooks/use-loading";
import campaignSegmentService from "@/services/campaign-segment.service";
import { RemoveByIdProps } from "@/types/requests.types";

import useRemove from "../../use-remove";

export type UseRemoveCampaignSegmentReturn = {
  remove: (props: RemoveByIdProps) => Promise<void>;
} & UseLoadingReturn;

const useRemoveCampaignSegment = (): UseRemoveCampaignSegmentReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, remove } = useRemove({
    operation: (segmentId) => campaignSegmentService.delete(segmentId),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    remove,
  };
};

export default useRemoveCampaignSegment;
